export default "__VITE_ASSET__fJboSlUU__"